import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Tooltip, IconButton } from "@mui/material";
import "./Toolbar.css";

// Normalize values to show "TBD" when empty/null/etc.
// const normalizeValue = (v) => {
//   if (v === null || v === undefined) return "TBD";
//   if (typeof v === "string") return v.trim() === "" ? "TBD" : v;
//   return v;
// };

// Apply italic + opacity when value is TBD
const getTextStyle = () => ({
  fontStyle: "normal",
  opacity: 1,
});

const fieldLabels = {
  itemId: "Item",
  siteCode: "Site Code",
  lob: "LOB",
  currencyTo: "Currency To",
  userName: "User Name",
  userEmail: "User Email"
};

const getStatusClassName = (value) => {
  if (!value) return "";
  return value.toString().trim().split(/\s+/).join("-").toLowerCase();
};

const Toolbar = ({
  number,
  exceptionType,
  stateType,
  leftIcon,
  rightIcon,
  toolbarActions,
  tooltipText,
  downloadAction,
  onBack,
  isCollapsed,
  toggleHeader,
  toolbarMeta,
  hideExpandButton = false
}) => {
  return (
    <div className="toolbar">
      <div className="toolbar-left">
        {/* Back Button */}
        <ChevronLeftIcon
          onClick={onBack}
          className="back-icon"
          role="button"
          aria-label="Go Back"
        />

        {/* Left Icon */}
        {leftIcon && (
          <span className="toolbar-icon" style={{ marginLeft: 4 }}>
            {leftIcon}
          </span>
        )}

        {toolbarMeta && (
          <div className="toolbar-heading" style={{ marginLeft: 4 }}>
            {/* Item Name */}
            <div className="toolbar-title-row">
              <div
                className="item-name"
                style={getTextStyle()}
              >
                {toolbarMeta?.heading || ""}
              </div>
            </div>

            {/* Meta Line */}
            <div className="meta-line">
              {toolbarMeta?.metaLine &&
                Object.entries(toolbarMeta.metaLine).map(([key, value], index, arr) => (
                  <span key={key} style={getTextStyle()}>
                    {`${fieldLabels[key]} : ${value || ""}`}
                    {arr.length > 1 && index < arr.length - 1 && " | "}
                  </span>
                ))}
            </div>
          </div>
        )}

        {/* Number */}
        <span className="toolbar-number" style={{ marginLeft: 4 }}>
          {number}
        </span>

        {/* Exception Type Badge */}
        {exceptionType && (
          <span
            className={`status-badge ${getStatusClassName(exceptionType)}`}
            style={{ marginLeft: 8 }}
          >
            {exceptionType}
          </span>
        )}

        {/* State Type Badge */}
        {stateType && (
          <span className="status-badge state-type-badge">
            {stateType}
          </span>
        )}
      </div>

      <div className="toolbar-right" style={{ display: 'flex', alignItems: 'center' }}>
        {/* Enable / Disable buttons */}
        {toolbarActions}

        {/* Download Icon */}
        {rightIcon && (
          <span className="toolbar-icon">
            <Tooltip title={tooltipText} placement="top" arrow>
              <IconButton onClick={downloadAction}
                sx={{
                  color: "#000",
                  '&:hover': {
                    color: '#656565'
                  }
                }}
              >
                {rightIcon}
              </IconButton>
            </Tooltip>
          </span>
        )}
      </div>
    </div>
  );
};

export default Toolbar;
